import urljoin from "url-join";

const SSO_BASE = window.RUNTIME_ENV.SSO_BASE_URL;
const API_BASE = window.RUNTIME_ENV.PROCESSING_API_URL;
const WS_BASE = window.RUNTIME_ENV.WS_BASE_URL;

export const NETWORK_INTERFACE_URL = urljoin(API_BASE, "graphql");
export const SSO_GET_TOKEN_URL = urljoin(SSO_BASE, "api/token-auth/");
export const SSO_RENEW_TOKEN_URL = urljoin(SSO_BASE, "api/token-refresh/");
export const SSO_RESTORE_PASS_URL = urljoin(SSO_BASE, "password_reset/");
export const OKTELL_WS_URL = urljoin(WS_BASE, "ws/oktell");

export const USE_RAVEN = true;



// WEBPACK FOOTER //
// ./src/config/config.prod.js